import './App.css';
import Home from './pages/index.js';

function App() {
  return (
    <>
    <Home/>
    </>
  );
}

export default App;
